export const relatorioConfig = {
    2: {
        nome: "Relatório Acompanhamento Consolidado Mensal",
        toRender: [
            { type: "mes", label: "Mês", name: "mesReferencia" }
        ]
    },
    4: {
        nome: "Relatório Acompanhamento Consolidado Mensal",
        toRender: [
            { type: "mes", label: "Data Inicio", name: "dataInicio" },
            { type: "mes", label: "Data Fim", name: "dataFim" }
        ]
    },
    5: {
        nome: "Relatório Acompanhamento Consolidado Trimestral",
        toRender: [
            { type: "mes", label: "Data Inicio", name: "dataInicio" },
            { type: "mes", label: "Data Fim", name: "dataFim" }
        ]
    },
    6: {
        nome: "Pendências Trimestrais XLSX",
        toRender: [
            { type: "mes", label: "Data Inicio", name: "dataInicio" },
            { type: "mes", label: "Data Fim", name: "dataFim" }
        ]
    },
    7: {
        nome: "Relatório Acompanhamento Consolidado Mensal (Capa)",
        toRender: [
            { type: "mes", label: "Mês", name: "mesReferencia" }
        ]
    },
    8: {
        nome: "Indicadores por Métrica",
        toRender: [
            { type: "select", label: "Indicador", name: "metricaId" },
            { type: "mes", label: "Data Inicio", name: "dataInicio" },
            { type: "mes", label: "Data Fim", name: "dataFim" },
        ]
    }
}